/** Vandaag-panel onboarding-hints: volgende-actie + focus-lijst-play. */
import { ONBOARDING_HINT_NEXT_ACTION_PANEL } from '@/constants/onboardingHints';
import { ONBOARDING_HINT_QUEUE_PRIORITIES } from '@/features/onboarding/constants/onboardingHintQueue';
import { useRegisterOnboardingQueuedHint } from '@/features/onboarding/context/useRegisterOnboardingQueuedHint';
import { useNextActionPanelHint } from '@/features/today/hooks/use-next-action-panel-hint';
import { useTodayFocusListHint } from '@/features/today/hooks/use-today-focus-list-hint';

/**
 * @param {Object} params
 * @param {boolean} params.showNextAction
 * @param {string | undefined} params.userId
 * @param {string | null | undefined} params.topActionableTaskId
 * @param {(key: string, fallback: string) => string} params.t
 */
export function useTodayViewPanelHints({
  showNextAction,
  userId,
  topActionableTaskId,
  t,
}) {
  const { showHint: showNextActionHint, dismissHint: dismissNextActionHint } =
    useNextActionPanelHint({
      panelVisible: showNextAction,
      userId,
    });
  const nextActionHintBody = t(
    'onboarding.nextActionPanel.body',
    'Hier staat de eerstvolgende stap van taken die je hebt opgesplitst.',
  );
  const { isActive: nextActionHintActive } = useRegisterOnboardingQueuedHint({
    id: ONBOARDING_HINT_NEXT_ACTION_PANEL,
    priority:
      ONBOARDING_HINT_QUEUE_PRIORITIES[ONBOARDING_HINT_NEXT_ACTION_PANEL],
    eligible: showNextAction,
    pending: showNextActionHint,
    body: nextActionHintBody,
    testId: 'next-action-panel-hint',
    onDismiss: dismissNextActionHint,
  });

  useTodayFocusListHint({ topActionableTaskId, userId });

  return { nextActionHintActive };
}
